
import {
    CardContent,
    Grid,
    Card as MuiCard,
    Box as MuiBox,
    Typography,
    Link
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { useHistory } from "react-router";
import styled from "styled-components/macro";
import { ReactComponent as GettingStartedDisabilityIcon } from "../../../../vendor/dashboard_screen_figure.svg";
import { useTranslation } from "react-i18next";

const gradient1 = "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)";
const gradient2 = "linear-gradient(90deg, #CFF37D 0%, #7DE88C 100%)";


const Card = styled(MuiCard)(spacing);
const Box = styled(MuiBox)(spacing);

const DisabilityIcon = styled(GettingStartedDisabilityIcon)`
  margin-right: ${(props) => props.theme.spacing(2)}px;
  margin-top: -2px;

  width: 100%;
  height: 100%;

  vertical-align: middle;
  display: inline;
`;
const CardWrapper = styled(Box)`
    width: 100%;
    border-radius: 4px;
    background: ${gradient1};
`;
const AmsCardContainer = styled(Card)`
    border: 1px solid rgba(8, 35, 48, 0.4);
    box-shadow: 0px 19.1739px 25.5652px rgba(8, 35, 48, 0.06), 0px 6.3913px 12.7826px rgba(8, 35, 48, 0.1);
    border-radius: 12px;
`;
const UrlTextWrapper = styled(Link)`
    color: #84FAB0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
    letter-spacing: 1px;
`
const AmsCardIndexContainer = styled(Box)`
    color: #202D40;
    width: 30px;
    height: 30px;
    display: flex;
    background: ${gradient2};
    align-items: center;
    border-radius: 8px;
    justify-content: center;
`
const AmsCardTextBox = styled(Box)`
    height: 40px;
    display: -webkit-box;
    overflow: hidden;
    white-space: break-spaces;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
`;

const GettingStartedWrapper = styled(Card)`
    background: ${gradient1};
    padding: 2px;
    border-radius:5px;
    box-shadow: 0px 2px 12px rgba(141, 238, 235, 0.8);
`


function AmsCardStep(props: {
    index: number;
    text: string;
    urlString: string;
    url: string;
}) {
    const { index, text, urlString, url } = props;
    const history = useHistory();
    return (
        <AmsCardContainer>
            <CardContent>
                <AmsCardIndexContainer mb={4} id="index-container">
                    <Typography variant="h6">
                        {index}
                    </Typography>
                </AmsCardIndexContainer>
                <AmsCardTextBox mb={2} title={text}>
                    <Typography variant="h6">
                        {text}
                    </Typography>
                </AmsCardTextBox>
                <Box mb={2}>
                    <UrlTextWrapper onClick={() => history.push(url)}>
                        {urlString}
                    </UrlTextWrapper>
                </Box>

            </CardContent>
        </AmsCardContainer>
    )
}

export function GettingStartedCard() {
    const { t } = useTranslation();
    return (
        <GettingStartedWrapper mb={6} >
            <CardContent style={{
                borderRadius: "5px",
                background: "#233145"
            }}>
                <CardWrapper mb={6}>
                    <Grid container style={{
                        padding: "15px"
                    }}>
                        <Grid item sm={2} xs={12} >
                            <DisabilityIcon />
                        </Grid>
                        <Grid item sm={10} xs={12} style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#333333",
                        }}>
                            <div>
                                <Typography variant="h2" gutterBottom>
                                    {t("gettingStartedCard_gettingStarted")}
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </CardWrapper>
                <Typography variant="subtitle1" gutterBottom>
                    {t("gettingStartedCard_Steps")}
                </Typography>
                <Grid container spacing={10}>
                    <Grid item lg={4} sm={6} xs={12}>
                        <AmsCardStep index={1} text={t("gettingStartedCard_step1")} urlString={t("gettingStartedCard_step1_link")} url="/documentation" />
                    </Grid>
                    <Grid item lg={4} sm={6} xs={12}>
                        <AmsCardStep index={2} text={t("gettingStartedCard_step2")} urlString={t("gettingStartedCard_step2_link")} url="/checklist"/>
                    </Grid>
                    <Grid item lg={4} sm={6} xs={12}>
                        <AmsCardStep index={3} text={t("gettingStartedCard_step3")} urlString={t("gettingStartedCard_step3_link")} url="/stats"/>
                    </Grid>
                </Grid>
            </CardContent>
        </GettingStartedWrapper>
    );
}